export default __webpack_public_path__ + "be82a6f28daa9b64cdc2b858cc9dd631.png";